import { call, put, takeEvery, takeLatest, delay } from "redux-saga/effects"
import { getTransportReport } from "./api"
import * as types from "./constant"

import { getTransportReportFailure, getTransportReportSuccess } from "./action"

function* getTransportReportAsync(action) {
  try {
    const response = yield call(getTransportReport, action.payload)
    yield put(getTransportReportSuccess(response.data))
  } catch (error) {
    yield put(getTransportReportFailure(error))
  }
}
export function* transportSaga() {
  yield takeLatest(types.GET_TRANSPORT_REPORT, getTransportReportAsync)
}


export default transportSaga